import colorPalette from "@/constants/colorPalette";

const {
  COLOR_DKBLUE,
  COLOR_TURQUISE,
  COLOR_RED,
  COLOR_WHITE,
  COLOR_DKGREY,
  COLOR_MEDGREY,
  COLOR_MEDGREY2,
  COLOR_LTGREY,
  COLOR_LTGREY2,
  COLOR_LTGREY3,
} = colorPalette;

const COLORS = {
  MARKER_RENT: COLOR_DKBLUE,
  MARKER_SHARE: COLOR_TURQUISE,
  MARKER_ABO: COLOR_TURQUISE,
  MARKER_SPECIAL: COLOR_TURQUISE,
  MARKER_SELECTED: COLOR_RED,
  MARKER_USER: COLOR_RED,
  LINE: COLOR_WHITE,
  MAPBG: COLOR_WHITE,
  LANDSCAPE: COLOR_LTGREY,
  WATER: COLOR_MEDGREY,
  ROAD_HIGHWAY: COLOR_WHITE,
  ROAD_ARTERIAL: COLOR_WHITE,
  ROAD_LOCAL: COLOR_WHITE,
  POI: COLOR_LTGREY,
  POI_PARK: COLOR_MEDGREY2,
  LABELS_TEXT_STROKE: COLOR_WHITE,
  LABELS_TEXT_FILL: COLOR_DKGREY,
  TRANSIT: COLOR_LTGREY2,
  ADMINISTRATIVE_FILL: COLOR_LTGREY3,
  ADMINISTRATIVE_STROKE: COLOR_LTGREY3,
};

const POINT_MARKER_ICON_RENTAL = {
  url:
    'data:image/svg+xml;utf-8, \
      <svg width="35" height="46" viewBox="0 0 35 46" xmlns="http://www.w3.org/2000/svg"> \
      <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_RENT +
    '" d="m15.477 45.072-2.9331-4.2271c-10.379-14.877-12.498-17.148-12.543-23.388l-7.3512e-4 -0.20717c0-9.5269 7.723-17.25 17.25-17.25 9.4187 0 17.074 7.5485 17.247 16.926l3e-3 0.32407c0 6.9551-2.4231 8.8973-15.477 27.822-0.85667 1.2375-2.6891 1.2375-3.5457 0z"/>\
      <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_ICON +
    '" d="M19.6082523,9 C21.0714194,9 22.3747725,9.83935689 22.9822468,11.1551605 L23.0607205,11.3375074 L23.6132075,12.7187411 L25.6010778,12.7187411 C25.8344491,12.7187411 26.0119042,12.9161423 25.9992989,13.1388621 L25.9878738,13.2138037 L25.7886555,14.0106768 C25.7508018,14.1626475 25.6283074,14.2758353 25.4788767,14.3050733 L25.4021838,14.3124873 L24.7357882,14.3124873 C25.1368123,14.6630259 25.4095624,15.1566252 25.4601021,15.7170535 L25.4685898,15.9062335 L25.4685898,17.4999797 C25.4685898,17.9760342 25.3069812,18.410636 25.0416073,18.7636821 L24.9373411,18.8921731 L24.9373411,20.6874721 C24.9373411,21.2350543 24.5228645,21.6860364 23.990596,21.7437337 L23.8748436,21.7499696 L22.8123462,21.7499696 C22.264764,21.7499696 21.8137819,21.335493 21.7560846,20.8032245 L21.7498487,20.6874721 L21.7498487,19.6249747 L13.249869,19.6249747 L13.249869,20.6874721 C13.249869,21.2350543 12.8353924,21.6860364 12.3031239,21.7437337 L12.1873715,21.7499696 L11.124874,21.7499696 C10.5772918,21.7499696 10.1263097,21.335493 10.0686125,20.8032245 L10.0623766,20.6874721 L10.0623766,18.8921731 C9.77196521,18.5598544 9.57808863,18.1412232 9.53859027,17.6763827 L9.53112784,17.4999797 L9.53112784,15.9062335 C9.53112784,15.3318954 9.76377549,14.8159162 10.1353709,14.4345275 L10.2642537,14.3124873 L9.59785818,14.3124873 C9.44105161,14.3124873 9.30156388,14.2210096 9.2370995,14.0832211 L9.2113864,14.0106768 L9.01216813,13.2138037 C8.95537925,12.987582 9.10381826,12.7675587 9.32310476,12.7258162 L9.39863991,12.7187411 L11.3861859,12.7187411 L11.9386729,11.3375074 C12.482088,9.97914023 13.7457783,9.0807239 15.1930261,9.00516854 L15.3914654,9 L19.6082523,9 Z M12.1873715,15.3749848 C11.5498665,15.3749848 11.124874,15.7986479 11.124874,16.4341749 C11.124874,17.0696696 11.5498665,17.4933326 12.1873715,17.4933326 C12.8248765,17.4933326 13.7811177,17.5992646 13.7811177,16.9637376 C13.7811177,16.3282429 12.8248765,15.3749848 12.1873715,15.3749848 Z M22.8123462,15.3749848 C22.1748412,15.3749848 21.2186,16.3282429 21.2186,16.9637376 C21.2186,17.4123449 21.6950662,17.4915055 22.1995636,17.4992637 L22.1995636,17.4992637 L22.8123462,17.4933326 C23.4498511,17.4933326 23.8748436,17.0696696 23.8748436,16.4341749 C23.8748436,15.7986479 23.4498511,15.3749848 22.8123462,15.3749848 Z M19.6082523,11.1249949 L15.3914654,11.1249949 C14.7898298,11.1249949 14.2441967,11.4630821 13.9734331,11.9909054 L13.9115953,12.1267282 L13.249869,13.7812386 L21.7498487,13.7812386 L21.0881224,12.1267282 C20.8460709,11.5217778 20.2600242,11.1249949 19.6082523,11.1249949 Z"></path> \
      </svg>',
};

const POINT_MARKER_ICON_SHARING = {
  url:
    'data:image/svg+xml;utf-8, \
  <svg width="35" height="46" viewBox="0 0 35 46" xmlns="http://www.w3.org/2000/svg"> \
  <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_SHARE +
    '" d="m15.477 45.072-2.9331-4.2271c-10.379-14.877-12.498-17.148-12.543-23.388l-7.3512e-4 -0.20717c0-9.5269 7.723-17.25 17.25-17.25 9.4187 0 17.074 7.5485 17.247 16.926l3e-3 0.32407c0 6.9551-2.4231 8.8973-15.477 27.822-0.85667 1.2375-2.6891 1.2375-3.5457 0z"/>\
  <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_ICON +
    '" d="M19.6082523,9 C21.0714194,9 22.3747725,9.83935689 22.9822468,11.1551605 L23.0607205,11.3375074 L23.6132075,12.7187411 L25.6010778,12.7187411 C25.8344491,12.7187411 26.0119042,12.9161423 25.9992989,13.1388621 L25.9878738,13.2138037 L25.7886555,14.0106768 C25.7508018,14.1626475 25.6283074,14.2758353 25.4788767,14.3050733 L25.4021838,14.3124873 L24.7357882,14.3124873 C25.1368123,14.6630259 25.4095624,15.1566252 25.4601021,15.7170535 L25.4685898,15.9062335 L25.4685898,17.4999797 C25.4685898,17.9760342 25.3069812,18.410636 25.0416073,18.7636821 L24.9373411,18.8921731 L24.9373411,20.6874721 C24.9373411,21.2350543 24.5228645,21.6860364 23.990596,21.7437337 L23.8748436,21.7499696 L22.8123462,21.7499696 C22.264764,21.7499696 21.8137819,21.335493 21.7560846,20.8032245 L21.7498487,20.6874721 L21.7498487,19.6249747 L13.249869,19.6249747 L13.249869,20.6874721 C13.249869,21.2350543 12.8353924,21.6860364 12.3031239,21.7437337 L12.1873715,21.7499696 L11.124874,21.7499696 C10.5772918,21.7499696 10.1263097,21.335493 10.0686125,20.8032245 L10.0623766,20.6874721 L10.0623766,18.8921731 C9.77196521,18.5598544 9.57808863,18.1412232 9.53859027,17.6763827 L9.53112784,17.4999797 L9.53112784,15.9062335 C9.53112784,15.3318954 9.76377549,14.8159162 10.1353709,14.4345275 L10.2642537,14.3124873 L9.59785818,14.3124873 C9.44105161,14.3124873 9.30156388,14.2210096 9.2370995,14.0832211 L9.2113864,14.0106768 L9.01216813,13.2138037 C8.95537925,12.987582 9.10381826,12.7675587 9.32310476,12.7258162 L9.39863991,12.7187411 L11.3861859,12.7187411 L11.9386729,11.3375074 C12.482088,9.97914023 13.7457783,9.0807239 15.1930261,9.00516854 L15.3914654,9 L19.6082523,9 Z M12.1873715,15.3749848 C11.5498665,15.3749848 11.124874,15.7986479 11.124874,16.4341749 C11.124874,17.0696696 11.5498665,17.4933326 12.1873715,17.4933326 C12.8248765,17.4933326 13.7811177,17.5992646 13.7811177,16.9637376 C13.7811177,16.3282429 12.8248765,15.3749848 12.1873715,15.3749848 Z M22.8123462,15.3749848 C22.1748412,15.3749848 21.2186,16.3282429 21.2186,16.9637376 C21.2186,17.4123449 21.6950662,17.4915055 22.1995636,17.4992637 L22.1995636,17.4992637 L22.8123462,17.4933326 C23.4498511,17.4933326 23.8748436,17.0696696 23.8748436,16.4341749 C23.8748436,15.7986479 23.4498511,15.3749848 22.8123462,15.3749848 Z M19.6082523,11.1249949 L15.3914654,11.1249949 C14.7898298,11.1249949 14.2441967,11.4630821 13.9734331,11.9909054 L13.9115953,12.1267282 L13.249869,13.7812386 L21.7498487,13.7812386 L21.0881224,12.1267282 C20.8460709,11.5217778 20.2600242,11.1249949 19.6082523,11.1249949 Z"></path> \
  </svg>',
};
const POINT_MARKER_ICON_ABO = {
  url:
    'data:image/svg+xml;utf-8, \
  <svg width="35" height="46" viewBox="0 0 35 46" xmlns="http://www.w3.org/2000/svg"> \
  <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_ABO +
    '" d="m15.477 45.072-2.9331-4.2271c-10.379-14.877-12.498-17.148-12.543-23.388l-7.3512e-4 -0.20717c0-9.5269 7.723-17.25 17.25-17.25 9.4187 0 17.074 7.5485 17.247 16.926l3e-3 0.32407c0 6.9551-2.4231 8.8973-15.477 27.822-0.85667 1.2375-2.6891 1.2375-3.5457 0z"/>\
  <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_ICON +
    '" d="M19.6082523,9 C21.0714194,9 22.3747725,9.83935689 22.9822468,11.1551605 L23.0607205,11.3375074 L23.6132075,12.7187411 L25.6010778,12.7187411 C25.8344491,12.7187411 26.0119042,12.9161423 25.9992989,13.1388621 L25.9878738,13.2138037 L25.7886555,14.0106768 C25.7508018,14.1626475 25.6283074,14.2758353 25.4788767,14.3050733 L25.4021838,14.3124873 L24.7357882,14.3124873 C25.1368123,14.6630259 25.4095624,15.1566252 25.4601021,15.7170535 L25.4685898,15.9062335 L25.4685898,17.4999797 C25.4685898,17.9760342 25.3069812,18.410636 25.0416073,18.7636821 L24.9373411,18.8921731 L24.9373411,20.6874721 C24.9373411,21.2350543 24.5228645,21.6860364 23.990596,21.7437337 L23.8748436,21.7499696 L22.8123462,21.7499696 C22.264764,21.7499696 21.8137819,21.335493 21.7560846,20.8032245 L21.7498487,20.6874721 L21.7498487,19.6249747 L13.249869,19.6249747 L13.249869,20.6874721 C13.249869,21.2350543 12.8353924,21.6860364 12.3031239,21.7437337 L12.1873715,21.7499696 L11.124874,21.7499696 C10.5772918,21.7499696 10.1263097,21.335493 10.0686125,20.8032245 L10.0623766,20.6874721 L10.0623766,18.8921731 C9.77196521,18.5598544 9.57808863,18.1412232 9.53859027,17.6763827 L9.53112784,17.4999797 L9.53112784,15.9062335 C9.53112784,15.3318954 9.76377549,14.8159162 10.1353709,14.4345275 L10.2642537,14.3124873 L9.59785818,14.3124873 C9.44105161,14.3124873 9.30156388,14.2210096 9.2370995,14.0832211 L9.2113864,14.0106768 L9.01216813,13.2138037 C8.95537925,12.987582 9.10381826,12.7675587 9.32310476,12.7258162 L9.39863991,12.7187411 L11.3861859,12.7187411 L11.9386729,11.3375074 C12.482088,9.97914023 13.7457783,9.0807239 15.1930261,9.00516854 L15.3914654,9 L19.6082523,9 Z M12.1873715,15.3749848 C11.5498665,15.3749848 11.124874,15.7986479 11.124874,16.4341749 C11.124874,17.0696696 11.5498665,17.4933326 12.1873715,17.4933326 C12.8248765,17.4933326 13.7811177,17.5992646 13.7811177,16.9637376 C13.7811177,16.3282429 12.8248765,15.3749848 12.1873715,15.3749848 Z M22.8123462,15.3749848 C22.1748412,15.3749848 21.2186,16.3282429 21.2186,16.9637376 C21.2186,17.4123449 21.6950662,17.4915055 22.1995636,17.4992637 L22.1995636,17.4992637 L22.8123462,17.4933326 C23.4498511,17.4933326 23.8748436,17.0696696 23.8748436,16.4341749 C23.8748436,15.7986479 23.4498511,15.3749848 22.8123462,15.3749848 Z M19.6082523,11.1249949 L15.3914654,11.1249949 C14.7898298,11.1249949 14.2441967,11.4630821 13.9734331,11.9909054 L13.9115953,12.1267282 L13.249869,13.7812386 L21.7498487,13.7812386 L21.0881224,12.1267282 C20.8460709,11.5217778 20.2600242,11.1249949 19.6082523,11.1249949 Z"></path> \
  </svg>',
};
const POINT_MARKER_ICON_SPECIAL = {
  url:
    'data:image/svg+xml;utf-8, \
  <svg width="35" height="46" viewBox="0 0 35 46" xmlns="http://www.w3.org/2000/svg"> \
  <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_SPECIAL +
    '" d="m15.477 45.072-2.9331-4.2271c-10.379-14.877-12.498-17.148-12.543-23.388l-7.3512e-4 -0.20717c0-9.5269 7.723-17.25 17.25-17.25 9.4187 0 17.074 7.5485 17.247 16.926l3e-3 0.32407c0 6.9551-2.4231 8.8973-15.477 27.822-0.85667 1.2375-2.6891 1.2375-3.5457 0z"/>\
  <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_ICON +
    '" d="M19.6082523,9 C21.0714194,9 22.3747725,9.83935689 22.9822468,11.1551605 L23.0607205,11.3375074 L23.6132075,12.7187411 L25.6010778,12.7187411 C25.8344491,12.7187411 26.0119042,12.9161423 25.9992989,13.1388621 L25.9878738,13.2138037 L25.7886555,14.0106768 C25.7508018,14.1626475 25.6283074,14.2758353 25.4788767,14.3050733 L25.4021838,14.3124873 L24.7357882,14.3124873 C25.1368123,14.6630259 25.4095624,15.1566252 25.4601021,15.7170535 L25.4685898,15.9062335 L25.4685898,17.4999797 C25.4685898,17.9760342 25.3069812,18.410636 25.0416073,18.7636821 L24.9373411,18.8921731 L24.9373411,20.6874721 C24.9373411,21.2350543 24.5228645,21.6860364 23.990596,21.7437337 L23.8748436,21.7499696 L22.8123462,21.7499696 C22.264764,21.7499696 21.8137819,21.335493 21.7560846,20.8032245 L21.7498487,20.6874721 L21.7498487,19.6249747 L13.249869,19.6249747 L13.249869,20.6874721 C13.249869,21.2350543 12.8353924,21.6860364 12.3031239,21.7437337 L12.1873715,21.7499696 L11.124874,21.7499696 C10.5772918,21.7499696 10.1263097,21.335493 10.0686125,20.8032245 L10.0623766,20.6874721 L10.0623766,18.8921731 C9.77196521,18.5598544 9.57808863,18.1412232 9.53859027,17.6763827 L9.53112784,17.4999797 L9.53112784,15.9062335 C9.53112784,15.3318954 9.76377549,14.8159162 10.1353709,14.4345275 L10.2642537,14.3124873 L9.59785818,14.3124873 C9.44105161,14.3124873 9.30156388,14.2210096 9.2370995,14.0832211 L9.2113864,14.0106768 L9.01216813,13.2138037 C8.95537925,12.987582 9.10381826,12.7675587 9.32310476,12.7258162 L9.39863991,12.7187411 L11.3861859,12.7187411 L11.9386729,11.3375074 C12.482088,9.97914023 13.7457783,9.0807239 15.1930261,9.00516854 L15.3914654,9 L19.6082523,9 Z M12.1873715,15.3749848 C11.5498665,15.3749848 11.124874,15.7986479 11.124874,16.4341749 C11.124874,17.0696696 11.5498665,17.4933326 12.1873715,17.4933326 C12.8248765,17.4933326 13.7811177,17.5992646 13.7811177,16.9637376 C13.7811177,16.3282429 12.8248765,15.3749848 12.1873715,15.3749848 Z M22.8123462,15.3749848 C22.1748412,15.3749848 21.2186,16.3282429 21.2186,16.9637376 C21.2186,17.4123449 21.6950662,17.4915055 22.1995636,17.4992637 L22.1995636,17.4992637 L22.8123462,17.4933326 C23.4498511,17.4933326 23.8748436,17.0696696 23.8748436,16.4341749 C23.8748436,15.7986479 23.4498511,15.3749848 22.8123462,15.3749848 Z M19.6082523,11.1249949 L15.3914654,11.1249949 C14.7898298,11.1249949 14.2441967,11.4630821 13.9734331,11.9909054 L13.9115953,12.1267282 L13.249869,13.7812386 L21.7498487,13.7812386 L21.0881224,12.1267282 C20.8460709,11.5217778 20.2600242,11.1249949 19.6082523,11.1249949 Z"></path> \
  </svg>',
};
const POINT_MARKER_ICON_BOTH = {
  url:
    'data:image/svg+xml;utf-8, \
    <svg width="35" height="46" viewBox="0 0 35 46" xmlns="http://www.w3.org/2000/svg"> \
      <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_RENT +
    '" d="m 15.712987,45.071999 -2.9331,-4.2271 C 2.4008872,25.967899 0.28188715,23.696899 0.23688715,17.4569 l -7.35e-4,-0.207171 c 0,-9.526899 7.72300005,-17.249999 17.24999985,-17.249999 9.418699,0 17.073999,7.548499 17.246999,16.925999 l 0.003,0.32407 c 0,6.9551 -2.4231,8.8973 -15.476999,27.822 -0.85667,1.2375 -2.6891,1.2375 -3.5457,0 z"/> \
      <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_SHARE +
    '" d="M 17.462549,0.00195313 C 7.946479,0.01478877 0.23598727,7.7310259 0.23598727,17.25 v 0.207031 c 0.045,6.24 2.16396883,8.511672 12.54296873,23.388672 l 2.933593,4.226563 c 0.423301,0.611527 1.085615,0.918643 1.75,0.925781 z"/> \
    <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_ICON +
    '" d="M19.6082523,9 C21.0714194,9 22.3747725,9.83935689 22.9822468,11.1551605 L23.0607205,11.3375074 L23.6132075,12.7187411 L25.6010778,12.7187411 C25.8344491,12.7187411 26.0119042,12.9161423 25.9992989,13.1388621 L25.9878738,13.2138037 L25.7886555,14.0106768 C25.7508018,14.1626475 25.6283074,14.2758353 25.4788767,14.3050733 L25.4021838,14.3124873 L24.7357882,14.3124873 C25.1368123,14.6630259 25.4095624,15.1566252 25.4601021,15.7170535 L25.4685898,15.9062335 L25.4685898,17.4999797 C25.4685898,17.9760342 25.3069812,18.410636 25.0416073,18.7636821 L24.9373411,18.8921731 L24.9373411,20.6874721 C24.9373411,21.2350543 24.5228645,21.6860364 23.990596,21.7437337 L23.8748436,21.7499696 L22.8123462,21.7499696 C22.264764,21.7499696 21.8137819,21.335493 21.7560846,20.8032245 L21.7498487,20.6874721 L21.7498487,19.6249747 L13.249869,19.6249747 L13.249869,20.6874721 C13.249869,21.2350543 12.8353924,21.6860364 12.3031239,21.7437337 L12.1873715,21.7499696 L11.124874,21.7499696 C10.5772918,21.7499696 10.1263097,21.335493 10.0686125,20.8032245 L10.0623766,20.6874721 L10.0623766,18.8921731 C9.77196521,18.5598544 9.57808863,18.1412232 9.53859027,17.6763827 L9.53112784,17.4999797 L9.53112784,15.9062335 C9.53112784,15.3318954 9.76377549,14.8159162 10.1353709,14.4345275 L10.2642537,14.3124873 L9.59785818,14.3124873 C9.44105161,14.3124873 9.30156388,14.2210096 9.2370995,14.0832211 L9.2113864,14.0106768 L9.01216813,13.2138037 C8.95537925,12.987582 9.10381826,12.7675587 9.32310476,12.7258162 L9.39863991,12.7187411 L11.3861859,12.7187411 L11.9386729,11.3375074 C12.482088,9.97914023 13.7457783,9.0807239 15.1930261,9.00516854 L15.3914654,9 L19.6082523,9 Z M12.1873715,15.3749848 C11.5498665,15.3749848 11.124874,15.7986479 11.124874,16.4341749 C11.124874,17.0696696 11.5498665,17.4933326 12.1873715,17.4933326 C12.8248765,17.4933326 13.7811177,17.5992646 13.7811177,16.9637376 C13.7811177,16.3282429 12.8248765,15.3749848 12.1873715,15.3749848 Z M22.8123462,15.3749848 C22.1748412,15.3749848 21.2186,16.3282429 21.2186,16.9637376 C21.2186,17.4123449 21.6950662,17.4915055 22.1995636,17.4992637 L22.1995636,17.4992637 L22.8123462,17.4933326 C23.4498511,17.4933326 23.8748436,17.0696696 23.8748436,16.4341749 C23.8748436,15.7986479 23.4498511,15.3749848 22.8123462,15.3749848 Z M19.6082523,11.1249949 L15.3914654,11.1249949 C14.7898298,11.1249949 14.2441967,11.4630821 13.9734331,11.9909054 L13.9115953,12.1267282 L13.249869,13.7812386 L21.7498487,13.7812386 L21.0881224,12.1267282 C20.8460709,11.5217778 20.2600242,11.1249949 19.6082523,11.1249949 Z"></path> \
  </svg>',
};
const POINT_MARKER_ICON_ACTIVE = {
  url:
    'data:image/svg+xml;utf-8, \
      <svg width="35" height="46" viewBox="0 0 35 46" xmlns="http://www.w3.org/2000/svg"> \
      <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_ACTIVE +
    '" d="m15.477 45.072-2.9331-4.2271c-10.379-14.877-12.498-17.148-12.543-23.388l-7.3512e-4 -0.20717c0-9.5269 7.723-17.25 17.25-17.25 9.4187 0 17.074 7.5485 17.247 16.926l3e-3 0.32407c0 6.9551-2.4231 8.8973-15.477 27.822-0.85667 1.2375-2.6891 1.2375-3.5457 0z"/>\
      <path fill="%23' +
    process.env.VUE_APP_CUSTOMER_MARKER_ICON +
    '" d="M19.6082523,9 C21.0714194,9 22.3747725,9.83935689 22.9822468,11.1551605 L23.0607205,11.3375074 L23.6132075,12.7187411 L25.6010778,12.7187411 C25.8344491,12.7187411 26.0119042,12.9161423 25.9992989,13.1388621 L25.9878738,13.2138037 L25.7886555,14.0106768 C25.7508018,14.1626475 25.6283074,14.2758353 25.4788767,14.3050733 L25.4021838,14.3124873 L24.7357882,14.3124873 C25.1368123,14.6630259 25.4095624,15.1566252 25.4601021,15.7170535 L25.4685898,15.9062335 L25.4685898,17.4999797 C25.4685898,17.9760342 25.3069812,18.410636 25.0416073,18.7636821 L24.9373411,18.8921731 L24.9373411,20.6874721 C24.9373411,21.2350543 24.5228645,21.6860364 23.990596,21.7437337 L23.8748436,21.7499696 L22.8123462,21.7499696 C22.264764,21.7499696 21.8137819,21.335493 21.7560846,20.8032245 L21.7498487,20.6874721 L21.7498487,19.6249747 L13.249869,19.6249747 L13.249869,20.6874721 C13.249869,21.2350543 12.8353924,21.6860364 12.3031239,21.7437337 L12.1873715,21.7499696 L11.124874,21.7499696 C10.5772918,21.7499696 10.1263097,21.335493 10.0686125,20.8032245 L10.0623766,20.6874721 L10.0623766,18.8921731 C9.77196521,18.5598544 9.57808863,18.1412232 9.53859027,17.6763827 L9.53112784,17.4999797 L9.53112784,15.9062335 C9.53112784,15.3318954 9.76377549,14.8159162 10.1353709,14.4345275 L10.2642537,14.3124873 L9.59785818,14.3124873 C9.44105161,14.3124873 9.30156388,14.2210096 9.2370995,14.0832211 L9.2113864,14.0106768 L9.01216813,13.2138037 C8.95537925,12.987582 9.10381826,12.7675587 9.32310476,12.7258162 L9.39863991,12.7187411 L11.3861859,12.7187411 L11.9386729,11.3375074 C12.482088,9.97914023 13.7457783,9.0807239 15.1930261,9.00516854 L15.3914654,9 L19.6082523,9 Z M12.1873715,15.3749848 C11.5498665,15.3749848 11.124874,15.7986479 11.124874,16.4341749 C11.124874,17.0696696 11.5498665,17.4933326 12.1873715,17.4933326 C12.8248765,17.4933326 13.7811177,17.5992646 13.7811177,16.9637376 C13.7811177,16.3282429 12.8248765,15.3749848 12.1873715,15.3749848 Z M22.8123462,15.3749848 C22.1748412,15.3749848 21.2186,16.3282429 21.2186,16.9637376 C21.2186,17.4123449 21.6950662,17.4915055 22.1995636,17.4992637 L22.1995636,17.4992637 L22.8123462,17.4933326 C23.4498511,17.4933326 23.8748436,17.0696696 23.8748436,16.4341749 C23.8748436,15.7986479 23.4498511,15.3749848 22.8123462,15.3749848 Z M19.6082523,11.1249949 L15.3914654,11.1249949 C14.7898298,11.1249949 14.2441967,11.4630821 13.9734331,11.9909054 L13.9115953,12.1267282 L13.249869,13.7812386 L21.7498487,13.7812386 L21.0881224,12.1267282 C20.8460709,11.5217778 20.2600242,11.1249949 19.6082523,11.1249949 Z"></path> \
      </svg>',
};

const USER_MARKER_ICON_CONFIG = {
  path: "M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0",
  strokeOpacity: 1,
  strokeWeight: 2,
  strokeColor: process.env.VUE_APP_CUSTOMER_MARKER_USER,
  fillColor: process.env.VUE_APP_CUSTOMER_MARKER_USER,
  fillOpacity: 1,
  scale: 1,
};

const LINE_SYMBOL_CONFIG = {
  path: "M 0,-2 0,2",
  strokeOpacity: 1,
  strokeWeight: 2,
  scale: 1,
};

const LINE_PATH_CONFIG = {
  clickable: false,
  geodesic: false,
  strokeOpacity: 0,
  strokeColor: COLORS.LINE,
  icons: [
    {
      icon: LINE_SYMBOL_CONFIG,
      repeat: "10px",
    },
  ],
};

const mapSettings = {
  clickableIcons: false,
  streetViewControl: false,
  panControlOptions: false,
  gestureHandling: "cooperative",
  backgroundColor: COLORS.MAPBG,
  mapTypeControl: false,
  mapTypeId: "roadmap",
  zoomControlOptions: {
    style: "SMALL",
  },
  zoom: 12,
  minZoom: 2,
  maxZoom: 20,
  styles: [
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: COLORS.WATER,
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        {
          color: COLORS.LANDSCAPE,
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: COLORS.ROAD_HIGHWAY,
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: COLORS.ROAD_HIGHWAY,
        },
        {
          lightness: 29,
        },
        {
          weight: 0.2,
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [
        {
          color: COLORS.ROAD_ARTERIAL,
        },
        {
          lightness: 18,
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: COLORS.ROAD_LOCAL,
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: COLORS.POI,
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: COLORS.POI_PARK,
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: COLORS.LABELS_TEXT_STROKE,
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      elementType: "labels.text.fill",
      stylers: [
        {
          saturation: 36,
        },
        {
          color: COLORS.LABELS_TEXT_FILL,
        },
        {
          lightness: 40,
        },
      ],
    },
    {
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [
        {
          color: COLORS.TRANSIT,
        },
        {
          lightness: 19,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: COLORS.ADMINISTRATIVE_FILL,
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: COLORS.ADMINISTRATIVE_STROKE,
        },
        {
          lightness: 17,
        },
        {
          weight: 1.2,
        },
      ],
    },
  ],
};

export {
  mapSettings,
  LINE_PATH_CONFIG,
  POINT_MARKER_ICON_RENTAL,
  POINT_MARKER_ICON_SHARING,
  POINT_MARKER_ICON_ABO,
  POINT_MARKER_ICON_SPECIAL,
  POINT_MARKER_ICON_BOTH,
  POINT_MARKER_ICON_ACTIVE,
  USER_MARKER_ICON_CONFIG,
};
